import React, {useEffect } from "react";
import Layout from "../components/ui/Layout";

const AccessibilityPage = () => {
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      {/* Skip to Content Link (For Accessibility) */}
      <a
        href="#design-system"
        className="sr-only focus:not-sr-only focus:fixed focus:top-0 focus:left-0 focus:bg-white focus:p-4 focus:z-50 focus:text-black focus:underline"
      >
        Skip to Content
      </a>
      <section className="bg-white text-black py-8">
        <div className="container mx-auto px-8 max-w-2xl">
          <p className="mb-4">
          I strive to make this website accessible for everyone, including people with situational, temporary or permanent disabilities.If you have difficulty viewing, navigating content, or notice any content that violates accessibility, please contact me: jiadiyounghe@gmail.com
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          </p>
        </div>
      </section>

  </Layout>
);
};


export default AccessibilityPage;